/**
 * Created by mauget on 3/1/16.
 */

// NotificationsDetailView.js

import $ from 'jquery';
import _ from 'lodash';
import Immutable from 'immutable';
import { View }  from 'backbone';

import BaseTableView    from 'properties/BaseTableView'
import DashboardModel   from 'DashboardModel';
import constants        from 'Constants';
import contentTemplate  from 'dashboard/notifications/detail-view.ejs';
import RestService      from 'RestService';
import eventBus         from 'EventBus';
import util             from 'util/Util.js';
import listService      from '../../../service/ListService';


class NotificationsDetailView extends BaseTableView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = '#propNotifyTable';
        this.model.set('notificationCount', 'No Notifications Need Attention', {silent: true});

        this.model.set({
            colModel: [
                {
                    name: 'icon',
                    index: 'icon',
                    width: 25,
                    editable: false,
                    sorttype: this.sortAttention
                },
                {
                    name: 'id',
                    index: 'id',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'isDraft',
                    index: 'isDraft',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'title',
                    index: 'title',
                    width: 445,
                    editable: false
                },
                {
                    name: 'date',
                    index: 'date',
                    width: 200,
                    editable: false
                },
                {
                    name: 'time',
                    index: 'time',
                    width: 200,
                    editable: false
                },
                {
                    name: 'formInstance',
                    index: 'formInstance',
                    width: 445,
                    editable: false
                },
                {
                    name: 'attentionLevel',
                    index: 'attentionLevel',
                    width: 245,
                    editable: false,
                    sorttype: this.sortAttention
                }
            ],
            colNames: ['&nbsp;', 'id', 'isDraft', 'Title', 'Date', 'Time', 'App Instance', 'Attention Level']
        });

        this.model.set('gridData',[], {silent: true});

        this.getAttentionNeededNotifications();

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    sortAttention(cell, rowObject){
      
        switch(rowObject.attentionLevel){
            case 'Normal':return 1;
            case 'High':return 2;
            case 'Urgent':return 3;
            case 'Very Urgent':return 4;
            case 'Extremely Urgent':return 5;
            default: return 0;
        }
    }

    getAttentionNeededNotifications() {
        // API call for GetPublished Forms in order to render them in the tree.
        RestService.getDashboardNotifications().then((data) => {
            let attentionNeededNotifications = data.NotificationList ? data.NotificationList.Notification : [];
            let gridData = [];

            // PF-5273 get show hidden value
            let showHiddenNotifications = listService.userSettings.get('_showHiddenNotifications_A');

            // Construct table
            if (attentionNeededNotifications && !(attentionNeededNotifications instanceof Array)) {
                attentionNeededNotifications = [attentionNeededNotifications];
            }
            if (attentionNeededNotifications.length <= 0) {
                for (let i = attentionNeededNotifications.length; i < 12; i++) {
                    let newRow = {
                        'icon': '',
                        'id': '',
                        'isDraft': '',
                        'title': '',
                        'date': '',
                        'time': '',
                        'formInstance': '',
                        'attentionLevel': ''
                    };
                    gridData.push(newRow);
                }
            }else {
                for (let i = 0; i < attentionNeededNotifications.length; i++) {
                    const icon = '<span class="icon fa fa-envelope" style="color: '+ util.getAttentionLevelColor(attentionNeededNotifications[i]['@AttentionLevel']) +'"></span>';
                    if (attentionNeededNotifications[i]['@AttentionLevel'] !== '0' && (showHiddenNotifications || attentionNeededNotifications[i]['@IsHidden'] !== 'True')) {
                        let newRow = {
                            'icon': icon,
                            'id': attentionNeededNotifications[i]['@NotificationId'],
                            'isDraft': attentionNeededNotifications[i]['@IsDraft'],
                            'title': attentionNeededNotifications[i]['@Title'],
                            'date': new Date(attentionNeededNotifications[i]['@Date'] + " GMT").toString("dd MMM yyyy"), // PF-5787 convert from GMT (server) to local timezone
                            'time': new Date(attentionNeededNotifications[i]['@Date'] + " GMT").toString("HH:mm"), 
                            'formInstance': attentionNeededNotifications[i]['@InstanceName'],
                            'attentionLevel': util.getAttentionLevel(attentionNeededNotifications[i]['@AttentionLevel'])
                        };
                        gridData.push(newRow);
                    }
                }

                if (gridData.length === 1) {
                    this.model.set('notificationCount', '1 Notification Needs Your Attention', {silent: true});
                } else {
                    this.model.set('notificationCount', gridData.length + ' Notifications Need Your Attention', {silent: true});
                }

                if (gridData.length < 12) {
                    for (let i = attentionNeededNotifications.length; i < 12; i++) {
                        let newRow = {
                            'icon': '',
                            'id': '',
                            'isDraft': '',
                            'title': '',
                            'date': '',
                            'time': '',
                            'formInstance': '',
                            'attentionLevel': ''
                        };
                        gridData.push(newRow);
                    }
                }
            }
            this.model.set('gridData', gridData);
        }).catch((error) => {
            console.log(error);
        });
    }


    initializeGrid() {
        let gridData = this.model.get('gridData');
        let actualSize = gridData.length;
        for (let i =0; i< actualSize; ++i) {
            $(this.gridEl).addRowData(i, gridData[i]);
        }

        if (actualSize < this.defaultGridSize) {
            for (let i =actualSize; i<this.defaultGridSize; ++i) {
                let defaultData = JSON.parse(JSON.stringify(this.emptyRow));
                gridData.push(defaultData);
                $(this.gridEl).addRowData(i, defaultData);
            }
            this.model.set('gridData', gridData);
        }
    }

    onSelectRow(rowId, status, e){
        let gridData = this.model.get('gridData');
        let notificationId = gridData[rowId].id;
        let itemId = 'attentionNeeded' + notificationId;
        eventBus.trigger('loadViewNotification', notificationId, 'attentionNeeded', itemId);
    }

    createGrid() {
        let self = this;
        $(self._gridEl).jqGrid({
            datatype: "local",
            altRows: true,
            cellEdit: false,
            shrinkToFit: true,
            autowidth: true,
            scrollOffset:0,
            height: 219,
            cellsubmit : 'clientArray',
            gridComplete: function() {
                $(self._gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
                $(self._gridEl + " [aria-describedby*='isDraft']").each( (index, value) => {
                    if(util.isTrue(value.innerText)){
                        value.parentElement.style.fontStyle = "italic";
                    }                   
                });
            },
            colNames: self.model.get('colNames'),
            colModel: self.model.get('colModel'),
            onSelectRow: function(rowId, status,e){
                self.onSelectRow(rowId, status,e);
            }
        });
        self.initializeGrid();
        self.resizeGrid();
    }

    render() {
        const html = this.template( this.model.toJSON() );

        $(this.$el[0]).html( html );

        this.createGrid();

        $('#detailHeading').html('Notifications - Dashboard');

        this.delegateEvents();
        this.$el.css( 'cursor', 'default' );

        return this;
    }

    refresh(){
        eventBus.trigger(constants.EV_REFRESH_NOTIFICATIONS_MAIN_VIEW_DETAILS)
    }

}

export default NotificationsDetailView;

